import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RbFabSpeedDialComponent } from './rb-fab-speed-dial.component';
import { RbFabItemDirective } from './rb-fab-item.directive';
import {MatIconModule, MatButtonModule} from '@angular/material';
@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  declarations: [RbFabSpeedDialComponent, RbFabItemDirective],
  exports: [RbFabSpeedDialComponent, RbFabItemDirective]
})
export class RbFabSpeedDialModule { }
